module.exports = __webpack_public_path__ + "static/about1-5d42369d626f7572c7640c25edfac2da.jpg";